import { Link } from "react-router-dom";
import styled from "styled-components/macro";

import icon_burger_mobile from "../../assets/icons/icon_burger_mobile.svg"
import { ReactComponent as SearchIcon } from "../../assets/icons/icon_search_mobile.svg";
import icon_shevron from "../../assets/icons/icon_shevron.svg"

type THeaderThemeProps = {
  $isDarkTheme?: boolean;
}

export const HeaderShell = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  padding-top: 18px;

  @media (max-width: 979px) {
    position: static;
    padding-top: 0;
  }
`;

export const HeaderContainer = styled.header<THeaderThemeProps>`
  width: 100%;
  max-width: 1320px;
  height: 64px;
  position: relative;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  color: ${({ $isDarkTheme }) => $isDarkTheme ? "#fff" : "#141414"};
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${({ $isDarkTheme }) => $isDarkTheme ? "rgba(11, 10, 15, 0.86)" : "rgba(255, 255, 255, 0.72)"};
  margin: 0 auto;
  padding: 0 15px;
  border-radius: 50px;
  border: 1px solid ${({ $isDarkTheme }) => $isDarkTheme ? "rgba(255, 255, 255, 0.14)" : "rgba(20, 20, 20, 0.14)"};
  box-shadow:
    inset 0 1px 0 ${({ $isDarkTheme }) => $isDarkTheme ? "rgba(255, 255, 255, 0.08)" : "rgba(255, 255, 255, 0.72)"},
    0 12px 32px ${({ $isDarkTheme }) => $isDarkTheme ? "rgba(0, 0, 0, 0.32)" : "rgba(20, 20, 20, 0.08)"};
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(20px);

  @media (max-width: 1439px) {
    max-width: calc(100% - 24px);
  }

  @media (max-width: 979px) {
    height: 58px;
    margin: 12px auto;
    padding: 0 15px;
    background: ${({ $isDarkTheme }) => $isDarkTheme ? "#0B0A0F" : "#fff"};
    border: 1px solid ${({ $isDarkTheme }) => $isDarkTheme ? "rgba(255, 255, 255, 0.14)" : "#141414"};
    box-shadow: none;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
  }
`;

export const HeaderLeft = styled.div`
  display: flex;
  gap: 10px;

  @media (min-width: 1024px) and (max-width: 1439px) {
    gap: 0;
  }

  @media (max-width: 979px) {
    display: none;
  }
`

export const MobileButton = styled.div`
  display: none;
  padding: 12px;
  cursor: pointer;

  @media (max-width: 979px) {
    display: block;
    padding: 15px;
  }
`

export const SearchMobile = styled(SearchIcon)<THeaderThemeProps>`
  width: 18px;
  height: 18px;
  display: block;

  path {
    stroke: ${({ $isDarkTheme }) => $isDarkTheme ? "#FFFFFF" : "#000000"};
  }
`

export const Logo = styled.img`
  position: absolute;
  cursor: pointer;
  width: 157px;
  height: 32px;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;

  @media (max-width: 979px) {
    width: 147px;
    height: 30px;
  }
`;

export const HeaderRight = styled.div`
  display: flex;
  gap: 10px;

  @media (min-width: 1024px) and (max-width: 1439px) {
    gap: 0;
  }

  @media (max-width: 979px) {
    display: none;
  }
`

export const BurgerMobile = styled.div<THeaderThemeProps>`
  width: 24px;
  height: 10px;
  display: none;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  background-image: url(${icon_burger_mobile});
  cursor: pointer;
  filter: ${({ $isDarkTheme }) => $isDarkTheme ? "brightness(0) invert(1)" : "none"};

  @media (max-width: 979px) {
    display: block;
  }
`

export const HeaderMenuButton = styled.div<THeaderThemeProps>`
  display: inline-flex;
  position: relative;
  border-radius: 16px;
  align-items: center;
  padding: 5px 12px;
  transition: 0.4s;
  cursor: pointer;

  &:hover {
     transition: 0.4s;
     background-color: ${({ $isDarkTheme }) => $isDarkTheme ? "#31303A" : "#DDDEE4"};
     color: ${({ $isDarkTheme }) => $isDarkTheme ? "#BFDCF5" : "inherit"};
  }
`

export const HeaderButton = styled(Link)<THeaderThemeProps>`
  display: inline-flex;
  position: relative;
  border-radius: 16px;
  text-decoration: none;
  color: inherit;
  align-items: center;
  padding: 5px 12px;
  transition: 0.4s;

  &:hover {
    transition: 0.4s;
    background-color: ${({ $isDarkTheme }) => $isDarkTheme ? "#31303A" : "#DDDEE4"};
    color: ${({ $isDarkTheme }) => $isDarkTheme ? "#BFDCF5" : "inherit"};
  }
`

export const Icon = styled.span<THeaderThemeProps>`
  display: inline-block;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 10px;
  height: 7px;
  margin-left: 7px;
  background-image: url(${icon_shevron});
  transition: 0.3s;
  filter: ${({ $isDarkTheme }) => $isDarkTheme ? "brightness(0) invert(1)" : "none"};
`

export const DropdownMenu = styled.ul<THeaderThemeProps>`
  position: absolute;
  top: 40px;
  left: 0;
  z-index: 10;
  display: none;
  flex-direction: column;
  background-color: ${({ $isDarkTheme }) => $isDarkTheme ? "rgba(11, 10, 15, 0.86)" : "#E8E9ED"};
  color: ${({ $isDarkTheme }) => $isDarkTheme ? "#FFFFFF" : "#141414"};
  border-radius: 16px;
  border: 1px solid ${({ $isDarkTheme }) => $isDarkTheme ? "rgba(255, 255, 255, 0.14)" : "E8E9ED"};
  width: 354px;
`

export const DropdownWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover ${DropdownMenu} {
    display: flex;
  }

  &:hover ${HeaderButton} {
    background-color: #DDDEE4;
  }

  &:hover ${Icon} {
    transform: rotate(-180deg);
    transition: 0.3s;
  }

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 0;
    height: 20px;
    width: 100px;
  }
`

export const IconDot = styled.span`
  display: none;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-left: 7px;
  background-color: #1983FF;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
`

export const MenuItem = styled(Link)<THeaderThemeProps>`
  position: relative;
  text-decoration: none;
  width: 100%;
  cursor: pointer;
  padding: 8px 12px;
  color: inherit;

  &:hover {
    color: ${({ $isDarkTheme }) => $isDarkTheme ? "#BFDCF5" : "#1983FF"};
  }

  &:hover ${IconDot} {
   display: block;
   background-color: ${({ $isDarkTheme }) => $isDarkTheme ? "rgb(191, 220, 245)" : "#1983FF"};
  }
`;

export const TGButton = styled.a<THeaderThemeProps>`
  padding: 5px 12px;
  background-color: ${({ $isDarkTheme }) => $isDarkTheme ? "#FFFFFF" : "#0088FF36"};
  color: ${({ $isDarkTheme }) => $isDarkTheme ? "#141414" : "#050F25"};
  border: 1px solid ${({ $isDarkTheme }) => $isDarkTheme ? "#FFFFFF" : "#000"};
  cursor: pointer;
  border-radius: 16px;
  text-decoration: none;
  transition: 0.4s;

  &:hover {
    background-color: ${({ $isDarkTheme }) => $isDarkTheme ? "#BFDCF5" : "black"};
    color: ${({ $isDarkTheme }) => $isDarkTheme ? "#141414" : "white"};
    border-color: ${({ $isDarkTheme }) => $isDarkTheme ? "#BFDCF5" : "black"};
    transition: 0.4s;
  }

  @media (max-width: 430px) {
    display: none;
  }
`
